import React, { useEffect, useState } from 'react';

const images = [
  "/1.png", 
  "/2.jpg", 
  "/3.jpg", 
  "/4.jpg", 
  "/5.jpg", 
  "/6.jpg"
];

const texts = [
  "Building the future, one structure at a time.",
  "Petriek Structures – Excellence in construction and real estate.",
  "From concept to completion, we bring your vision to life.",
  "Reliable, innovative, and built to last – that's Petriek Structures.",
  "Your trusted partner in construction and real estate development.",
  "Building the future, one structure at a time.",
];

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  // Change image and text every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 4000);

    return () => clearInterval(interval); // Clear the interval on component unmount
  }, []);

  const transitionStyles = [
    "animate-slideInLeft",
    "animate-slideInRight",
    "animate-slideInTop",
    "animate-slideInBottom",
    "animate-fadeIn"
  ];

  return (
    <section className="relative h-[60vh] md:h-[80vh] overflow-hidden">
       <div
        className="absolute inset-0 bg-cover bg-center filter blur-lg scale-110"
        style={{ backgroundImage: `url(${images[4]})` }} // First image as blurred BG
      ></div>
      {/* Static Image Slider */}
      <div className="relative w-full h-full">
        <img
          src={images[currentImageIndex]} // Display image based on currentImageIndex
          alt={`Slide ${currentImageIndex}`}
          className={`w-full h-full object-cover ${transitionStyles[currentImageIndex % transitionStyles.length]}`}
        />
      </div>

      {/* Black Overlay with 80% opacity */}
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-0"></div>

      {/* Centered text over image with dynamic adjustments */}
      <div className="absolute inset-0 flex justify-center items-center z-10 text-white text-center px-6 sm:px-12">
        <div className="text-4xl sm:text-6xl font-semibold max-w-full sm:max-w-3xl">
          <div
            className="mb-4"
            style={{
              whiteSpace: 'normal',
              lineHeight: '1.5',
              wordWrap: 'break-word',
              animationDelay: '0.5s', // delay to allow the text to appear smoothly
              // Adding some custom margins for mobile view to avoid text being too high
              marginTop: '10%',  // Adjusted for mobile screens
              marginBottom: '10%' // To ensure text doesn't go too high or low
            }}
          >
            {texts[currentTextIndex]}
          </div>
        </div>
      </div>

      {/* Adding the CSS for the animations */}
      <style jsx>{`
        @keyframes slideInLeft {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideInRight {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideInTop {
          0% {
            transform: translateY(-100%);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes slideInBottom {
          0% {
            transform: translateY(100%);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        .animate-slideInLeft {
          animation: slideInLeft 1s ease-out forwards;
        }

        .animate-slideInRight {
          animation: slideInRight 1s ease-out forwards;
        }

        .animate-slideInTop {
          animation: slideInTop 1s ease-out forwards;
        }

        .animate-slideInBottom {
          animation: slideInBottom 1s ease-out forwards;
        }

        .animate-fadeIn {
          animation: fadeIn 1s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default Hero;
